import type { DashboardDataWithEditable, DashboardGetInput, DashboardId, DashboardGetSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { dashboardKey } from '../keys'
import type { GetHookResponse } from '../hooks'

export function useDashboard(dashboardId: DashboardId): GetHookResponse<DashboardDataWithEditable> {
  return useTantalimQuery<DashboardGetInput, DashboardGetSuccess, DashboardDataWithEditable>({
    url: '/report/dashboard/get',
    queryKey: dashboardKey(dashboardId),
    input: {
      dashboardId,
    },
    convertResponse: (data) => {
      return data.dashboard
    },
  })
}
